module.exports = __webpack_public_path__ + "img/school.65b8c311.jpeg";